<template>
  <div>
    <el-card>
      <div class="mb-16" style="margin-bottom: 24px">
        <span>{{ $t('purchase::purchase-list::quick_sort') }}</span>
        <el-checkbox-group class="purchase--order__quickSort" v-model="statusList">
          <el-checkbox v-for="item in controlStatus" :key="item.value" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <z-search :configs="listConfigs" @do-query="query" ref="purchase" v-model="searchData"></z-search>
    </el-card>
    <el-card class="mt10">
      <div>
        <div class="mb-16">
          <el-button
            @click="addPurchaseOrder"
            icon="el-icon-plus"
            type="primary"
            v-auth="'purchase::purchase-list::purchase-add'"
          >
            {{ $t('purchase::purchase-list::add_supplier') }}
          </el-button>
        </div>
      </div>
      <z-table
        :columns="orderColumns"
        :data="lists"
        :max-height="550"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
        v-loading="loading"
      >
        <template #purchaseNo="{ row }">
          <span>{{ $dataCheck(row.purchaseNo) }}</span>
          <el-progress :percentage="progress(row)" color="#70b603" v-if="row"></el-progress>
        </template>
        <template #createInfo="{ row }">
          <p>{{ $t('purchase::purchase-list::creator') }}：{{ $dataCheck(row.createName) }}</p>
          <p>{{ $t('purchase::purchase-list::create_time') }}：{{ $dataCheck(row.createTime) }}</p>
        </template>
        <template #auditInfo="{ row }">
          <p>{{ $t('purchase::purchase-list::auditor') }}：{{ $dataCheck(row.auditorName) }}</p>
          <p>{{ $t('purchase::purchase-list::audit_time') }}：{{ $dataCheck(row.auditTime) }}</p>
        </template>
        <template #reviewInfo="{ row }">
          <p>{{ $t('purchase::purchase-list::re_auditor') }}：{{ $dataCheck(row.reviewerName) }}</p>
          <p>{{ $t('purchase::purchase-list::re_audit_time') }}：{{ $dataCheck(row.reviewTime) }}</p>
        </template>
        <template #purchaseStatusName="{ row }">
          <i :style="{ background: statusToColor[row.purchaseStatus] }" class="round"></i>
          <span>{{ PRUCHASE_STATUS[row.purchaseStatus] }}</span>
        </template>
        <template #operate="{ row }">
          <el-button
            @click="openDialog(row, 1)"
            type="text"
            v-auth="'purchase::purchase-list::examine'"
            v-if="row.purchaseStatus === 1"
          >
            {{ $t('purchase::purchase-list::audit') }}
          </el-button>
          <el-button
            @click="openDialog(row, 2)"
            type="text"
            v-auth="'purchase::purchase-list::re-examine'"
            v-if="row.purchaseStatus === 2"
          >
            {{ $t('purchase::purchase-list::re_audit') }}
          </el-button>
          <el-button
            @click="$router.push(`/purchase/detail/${row.id}`)"
            type="text"
            v-auth="'purchase::purchase-list::purchase-detail'"
            v-if="row.purchaseStatus !== 1"
          >
            {{ $t('purchase::purchase-list::detail') }}
          </el-button>
          <el-button
            @click="$router.push(`/purchase/edit/${row.id}`)"
            type="text"
            v-auth="'purchase::purchase-list::purchase-edit'"
            v-if="row.purchaseStatus === 1"
          >
            {{ $t('purchase::purchase-list::edit') }}
          </el-button>
          <el-button
            @click="openDialog(row, 3)"
            type="text"
            v-auth="'purchase::purchase-list::in-stock'"
            v-if="[3, 4, 5].some(i => i === row.purchaseStatus)"
          >
            {{ $t('purchase::purchase-list::in_stock') }}
          </el-button>
          <el-button
            @click="openDialog(row, 4)"
            style="color: #d9001b"
            type="text"
            v-auth="'purchase::purchase-list::close'"
            v-if="[2, 3].some(i => i === row.purchaseStatus)"
          >
            {{ $t('purchase::purchase-list::close') }}
          </el-button>
          <el-button
            @click="openDialog(row, 5)"
            style="color: #d9001b"
            type="text"
            v-auth="'purchase::purchase-list::delete'"
            v-if="row.purchaseStatus === 1"
          >
            {{ $t('purchase::purchase-list::delete') }}
          </el-button>
          <el-button
            @click="openDialog(row, 6)"
            type="text"
            v-auth="'purchase::purchase-list::complete'"
            v-if="[4, 5].some(i => i === row.purchaseStatus)"
          >
            {{ $t('purchase::purchase-list::finished') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" width="500px">
      <div slot="title" style="font-size: 18px">
        <i class="el-icon-warning" style="color: #999; margin-right: 10px" v-if="editRow.editType !== 3"></i>
        <span v-if="editRow.editType === 1">{{ $t('purchase::purchase-list::audit_confirm') }}</span>
        <span v-if="editRow.editType === 2">{{ $t('purchase::purchase-list::re_audit_confirm') }}</span>
        <span v-if="editRow.editType === 3">{{ $t('purchase::purchase-list::purchase_in_stock') }}</span>
        <span v-if="editRow.editType === 4">{{ $t('purchase::purchase-list::close_purchase_order') }}</span>
        <span v-if="editRow.editType === 5">{{ $t('purchase::purchase-list::purchase_delete') }}</span>
        <span v-if="editRow.editType === 6">{{ $t('purchase::purchase-list::purchase_finished') }}</span>
      </div>
      <div>
        <p v-if="editRow.editType !== 3">
          {{ $t('purchase::purchase-list::puechase_order_num') }}：{{ editRow.purchaseNo }}
        </p>
        <p v-if="editRow.editType === 4">{{ $t('purchase::purchase-list::close_confirm') }}</p>
        <p v-if="editRow.editType === 5">{{ $t('purchase::purchase-list::delete_confirm') }}</p>
        <p v-if="editRow.editType === 6">{{ $t('purchase::purchase-list::setting_confirm') }}</p>
        <template v-if="editRow.editType === 3">
          <div :key="item.id" class="sku-item" v-for="item in editRow.list">
            <div class="sku-wrap">
              <el-image :src="item.img" style="width: 50px; height: 50px"></el-image>
              <div class="sku-info">
                <p class="spu-name one-line">{{ item.spuName }}</p>
                <p>SKU: {{ item.skuId }}</p>
                <p>
                  {{ $t('purchase::purchase-list::purchase_amount') }}：{{ item.skuBuyQuantity }}
                  <span class="array-number">
                    {{ $t('purchase::purchase-list::arrival_amount') }}：{{ item.skuArrivalQuantity }}
                  </span>
                </p>
              </div>
            </div>
            <el-input :placeholder="$t('purchase::purchase-list::in_stock_this_time_num')" v-model="item.qty">
              <template slot="prepend">{{ $t('purchase::purchase-list::in_stock_this_time') }}</template>
            </el-input>
          </div>
        </template>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('purchase::purchase-list::cancel') }}</el-button>
        <el-button @click="editOrder" type="primary">{{ $t('purchase::purchase-list::confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listConfigs, controlStatus, orderColumns, statusToColor } from '@/views/purchase/config'
import { getPurchaseList, checkPurchaseOrder, deletePurchaseOrder } from '@/server/purchase'
import { addAndCheckStockOrder } from '@/server/stock'
import { PRUCHASE_STATUS } from '@/config'
export default {
  data() {
    return {
      listConfigs,
      controlStatus,
      orderColumns,
      statusToColor,
      PRUCHASE_STATUS,
      searchData: {},
      lists: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      statusList: ['1', '2', '3', '4', '5', '6'],
      loading: false,
      dialogVisible: false,
      editRow: '',
    }
  },
  created() {
    this.getLists()
  },
  methods: {
    routerTo(row) {
      if (row.purchaseStatus === 1) this.$router.push(`/purchase/edit/${row.id}`)
      else this.$router.push(`/purchase/detail/${row.id}`)
    },
    query(params) {
      this.getLists(params)
    },
    addPurchaseOrder() {
      this.$router.push('/purchase/add')
    },
    handlePageChange() {
      this.getLists()
    },
    async getLists(searchData = this.searchData) {
      this.loading = true
      const { data } = await getPurchaseList({
        ...searchData,
        ...this.pagination,
        statusList: this.statusList,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.lists = data.data.items
        this.lists.forEach(item => {
          if (item.list && item.list.length > 0) {
            item.list = item.list.map(i => ({
              ...i,
              qty: 0,
            }))
          }
        })
        this.pagination.total = data.data.totalCount
      }
    },
    openDialog(row, type) {
      this.editRow = {
        ...row,
        editType: type,
      }
      this.dialogVisible = true
    },
    progress(row) {
      const progress = (row.arrival / row.buy) * 100
      return row.buy > 0 ? parseInt(progress) : 0
    },
    async editOrder() {
      const editRow = this.editRow
      if ([1, 2, 4, 6].some(item => item === editRow.editType)) {
        let type = 0
        switch (editRow.editType) {
          case 1:
            type = 2
            break
          case 2:
            type = 3
            break
          case 4:
            type = 7
            break
          case 6:
            type = 6
            break
        }
        const { data } = await checkPurchaseOrder(editRow.id, type)
        if (data.code === this.$code) {
          this.getLists()
          this.dialogVisible = false
        }
      }
      if (editRow.editType === 5) {
        const { data } = await deletePurchaseOrder(editRow.id)
        if (data.code === this.$code) {
          this.getLists()
          this.dialogVisible = false
        }
      }
      if (editRow.editType === 3) {
        const { data } = await addAndCheckStockOrder({
          type: 1,
          sourceNoType: 1,
          sourceNo: editRow.purchaseNo,
          supplierId: editRow.supplierId,
          detailList: editRow.list.map(item => ({
            ...item,
            totalPrice: item.skuTotal,
            skuPropertys: item.optionValueNames,
            id: null,
          })),
          methodType: 2, // 采购订单-2
        })
        if (data.code === this.$code) {
          this.getLists()
          this.dialogVisible = false
        }
      }
    },
  },
  watch: {
    statusList() {
      this.getLists()
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #010517;
}
.sku-list {
  color: red;
}
.sku-item {
  border: 1px solid #aaa;
  padding: 5px;
  margin-bottom: 10px;
  .sku-wrap {
    display: flex;
    padding-bottom: 5px;
    .sku-info {
      margin-left: 10px;
      .spu-name {
        width: 350px;
      }
      .array-number {
        color: rgb(245, 154, 35);
        margin-left: 50px;
      }
    }
  }
}
.round {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
}
.purchase--order__quickSort {
  display: inline-block;
  margin-left: 24px;
  /deep/ .el-checkbox {
    margin-right: 16px;
  }
}
</style>
